import { useDispatch, useSelector } from "react-redux";
import UploadButton from "../../components/UploadButton";
import { selectTranslations } from "../../services/i18n/i18nSlice";
import { useEffect, useState } from "react";
import SecureImage from "../../components/_partials/SecuredImage";
import { API_URL } from "../../config/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchCreateNewFolder, fetchGetSubFolders } from "./FolderApi";
import { selectUserData } from "../../features/User/userSlice";
import { toast } from "react-toastify";
import { setLoading } from "../../services/global/globalSlice";

export default function CreateFolderScreen() {

    const t = useSelector(selectTranslations)
    const userData = useSelector(selectUserData)
    const [folderData,setFolderData] = useState({})
    const [subFolders, setSubFolders] = useState([])

    const {parent_folder_id} = useParams()

    const navigate =  useNavigate()
    const dispatch = useDispatch()

    const loadSubFolders = async () => {
        dispatch(setLoading(true))
        const response = await fetchGetSubFolders({parent_folder_id: parent_folder_id})
        if (response.success){
            setSubFolders(response.data.folders)
            dispatch(setLoading(false))
        } else {
            toast.error(t.training.error_loading_folder)
        }
    } 

    const handleEditFolderIcon = (e) => {
        console.log(e);
        setFolderData({
            ...folderData,
            icon_url: e
        })
    }

    const handleEditFolder = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        setFolderData({
            ...folderData,
            [name]: value
        })
    }

    const handleCreateFolder = async () => {
        dispatch(setLoading(true))
        let _folderData = structuredClone(folderData)
        _folderData = {
            ..._folderData,
            parent_folder_id: parent_folder_id,
            state: 'draft',
            videos: [],
            files: [],
            links: [],
            priority: subFolders && subFolders.length > 0 ? subFolders[subFolders.length -1].priority + 1 : 1,
            allowed_admins: [userData.user_id]
        }
        const response = await fetchCreateNewFolder(_folderData)
        if(response.success){
            toast.success(t.folder.folder_created)
            navigate(`/folder/${response.data.folder_id}`,{replace:true})
        } else {
            toast.error(t.folder.error_creating)
        }
        dispatch(setLoading(false))
    }

    useEffect(()=>{
        loadSubFolders()
    },[parent_folder_id])

    return (
        <div className="create_folder_screen">
            <input type="text" value={folderData.name || ''} name="name" placeholder={t.folder.folder_name} onChange={handleEditFolder} />
            
            {folderData?.icon_url ?
                <div style={{maxWidth:'150px'}}>
                    <span>Icona:</span>
                    <SecureImage className="w-100" imageUrl={`${API_URL}${folderData.icon_url}`} />
                </div>
            : <UploadButton label={t.folder.add_icon} type="personalization" onUpload={handleEditFolderIcon} accept="image/png, image/gif, image/jpeg" showProgress={true}/>}
            <footer className='control-footer'>
                <div className='d-flex align-items-center justify-content-between'>
                    <div>
                        <Link to={`/folder/${parent_folder_id}`}>
                            <u>{t.buttons.exit_without_save}</u>
                        </Link>
                    </div>
                    <div className='d-flex justify-content-end'>
                        <button disabled={!folderData?.name || folderData?.name === ""} className='ms-2' onClick={handleCreateFolder}>
                            {t.folder.create_folder}
                        </button>
                    </div>
                </div>
            </footer>
        </div>
    )
}